import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StatsigProvider } from "statsig-react";
import { JobsTable } from "./pages/JobsTablePage";
import { TaskDetail } from "./pages/TaskDetail";
import { Layout } from "./components/Layout";
import "@/utils/auth";
import { auth, waitForAuth } from "@/utils/auth";
import { useNavigate, useLocation } from "react-router-dom";
import { Login } from "./pages/Login";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthReady, setIsAuthReady] = useState(false);

  // Create a QueryClient instance
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            retry: 1,
          },
        },
      }),
  );

  useEffect(() => {
    const initAuth = async () => {
      try {
        await waitForAuth();
        setIsAuthReady(true);
      } catch (error) {
        navigate("/login");
      }
    };

    auth.onAuthStateChanged(async (user) => {
      if (!user) {
        navigate("/login");
      } else {
        setIsAuthReady(true);
      }
    });

    initAuth();
  }, [navigate]);

  if (!isAuthReady && location.pathname !== "/login") return null;
  return (
    <QueryClientProvider client={queryClient}>
      <StatsigProvider
        sdkKey={import.meta.env.VITE_STATSIG_CLIENT_KEY}
        user={{
          userID: auth.currentUser?.uid,
          email: auth.currentUser?.email || undefined,
        }}
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <Layout>
                <Routes>
                  <Route path="/" element={<JobsTable />} />
                  <Route
                    path="/jobs/:jobId/product-association"
                    element={<TaskDetail mode="viewer" />}
                  />
                  <Route
                    path="/jobs/:jobId/admin-product-association"
                    element={<TaskDetail mode="admin" />}
                  />
                  <Route
                    path="/jobs/:jobId/qa-jobs"
                    element={<TaskDetail mode="qa" />}
                  />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </StatsigProvider>
    </QueryClientProvider>
  );
}

export default App;
